/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProjectCustomDataResponsePartOf
 */
export interface GetProjectCustomDataResponsePartOf {
    /**
     * 
     * @type {string}
     * @memberof GetProjectCustomDataResponsePartOf
     */
    icon: string;
    /**
     * 
     * @type {number}
     * @memberof GetProjectCustomDataResponsePartOf
     */
    pid: number;
    /**
     * 
     * @type {string}
     * @memberof GetProjectCustomDataResponsePartOf
     */
    projectname: string;
}

export function GetProjectCustomDataResponsePartOfFromJSON(json: any): GetProjectCustomDataResponsePartOf {
    return GetProjectCustomDataResponsePartOfFromJSONTyped(json, false);
}

export function GetProjectCustomDataResponsePartOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectCustomDataResponsePartOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'icon': json['icon'],
        'pid': json['pid'],
        'projectname': json['projectname'],
    };
}

export function GetProjectCustomDataResponsePartOfToJSON(value?: GetProjectCustomDataResponsePartOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'icon': value.icon,
        'pid': value.pid,
        'projectname': value.projectname,
    };
}


